import { userApi } from './index';
import { config } from '../config';
import { IGetRegularPaymentSettingsResponse } from '../../../models/RegularPayment';

export interface RegularPaymentsEnableProps {
  cardId: string;
  email: string;
}

export const regularPaymentsApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    enableRegularPayment: build.mutation<{ success: string }, RegularPaymentsEnableProps>({
      query: ({ cardId, email }) => ({
        method: 'POST',
        url: config.REGULAR_PAYMENTS.ENABLE,
        body: {
          card_id: cardId,
          email,
        },
      }),
      invalidatesTags: ['RegularPayment'],
    }),
    disableRegularPayment: build.mutation<{ success: string }, string>({
      query: (email) => ({
        method: 'POST',
        url: config.REGULAR_PAYMENTS.DISABLE,
        body: {
          email,
        },
      }),
      invalidatesTags: ['RegularPayment'],
    }),
    getSettings: build.query<IGetRegularPaymentSettingsResponse, string>({
      query: () => ({
        url: config.REGULAR_PAYMENTS.GET_SETTINGS,
      }),
      providesTags: () => ['RegularPayment'],
    }),
    deleteRegularPaymentEmail: build.mutation<string, string>({
      query: () => ({
        method: 'DELETE',
        url: config.REGULAR_PAYMENTS.CHANGE_EMAIL,
      }),
      invalidatesTags: ['RegularPayment'],
    }),
    switchRegularPayment: build.mutation<{ success: string }, { cardId: string; status: 0 | 1 }>({
      query: ({ cardId, status }) => ({
        method: 'PATCH',
        url: config.REGULAR_PAYMENTS.SWITCH_REGULAR_PAYMENT,
        body: {
          card_id: cardId,
          status,
        },
      }),
      invalidatesTags: ['RegularPayment'],
    }),
    changeRegularPaymentEmail: build.mutation<{ success: string }, string>({
      query: (Email) => ({
        method: 'PATCH',
        url: config.REGULAR_PAYMENTS.CHANGE_EMAIL,
        body: {
          Email,
        },
      }),
      invalidatesTags: ['RegularPayment'],
    }),
    setPaymentCard: build.mutation<{ success: string }, { cardId: string }>({
      query: ({ cardId }) => ({
        method: 'PATCH',
        url: config.REGULAR_PAYMENTS.SET_PAYMENT_CARD,
        body: {
          CardID: cardId,
        },
      }),
      invalidatesTags: ['RegularPayment'],
    }),
  }),
});
